import { render, staticRenderFns } from "./IconMoveTo.vue?vue&type=template&id=d3cb365e&"
import script from "./IconMoveTo.vue?vue&type=script&lang=js&"
export * from "./IconMoveTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports